import { createInertiaApp } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import type { DefineComponent } from 'vue'
import { createSSRApp, h } from 'vue'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<DefineComponent>('./pages/**/*.vue')
    const templates = import.meta.glob<DefineComponent>('../../templates/*/*.vue')

    if (name.startsWith('collections/')) {
      const slug = name.replace('collections/', '')
      return resolvePageComponent(`../../templates/${slug}/${slug}.vue`, templates)
    }

    return resolvePageComponent(`./pages/${name}.vue`, pages)
  },
  setup({ el, App, props, plugin }) {
    createSSRApp({ render: () => h(App, props) })
      .use(plugin)
      .mount(el)
  },
})
